import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

const propTypes = {
    //autoFocus: PropTypes.bool,            // Focus on input on load
    className: PropTypes.string,            // Custom class name to add to input container
    disabled: PropTypes.bool,               // Disable input
    //disableEmptyOption: PropTypes.bool,   // if true , it does not show the first option as empty
    footerItem: PropTypes.object,           // Object for alternative group option for bottom of dropdown
    headerItem: PropTypes.object,           // Object for 'select all' except for footer option for top of dropdown
    //id: PropTypes.string,                 // Input id    
    //inputErrorMsg: PropTypes.string,      // Input inline error message    
    name: PropTypes.string,                 // Input name   
    //onChange: PropTypes.func,             // Function triggered on onChange     
    onDismiss: PropTypes.func,              // Function triggered when dropdown closes
    //onFocus: PropTypes.func,              // Function triggered on focus    
    listItems: PropTypes.array,             // Array of options
    placeholder: PropTypes.string,          // Input placeholder text
    //prependIcon: PropTypes.string,        // Class of icon to display at beginning of input
    //required: PropTypes.bool,             // Set to true so input empty validation check will trigger on blur and keypress
    showAsInvalid: PropTypes.bool           // Override component validation and display input as invalid        
};

export default class DropdownForm extends React.Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.onFooterItemSelected = this.onFooterItemSelected.bind(this);
        this.onHeaderItemSelected = this.onHeaderItemSelected.bind(this);
        this.onListItemSelected = this.onListItemSelected.bind(this);
        this.onDoneClicked = this.onDoneClicked.bind(this);
        this.updateDropDownList = this.updateDropDownList.bind(this);

        const { headerItem, footerItem, listItems } = this.props;

        this.state = {
            invalidInput: false,
            dropdownOpen: false,
            touched: false,
            isFooterItemSelected: footerItem ? footerItem.selected || !listItems || listItems.length === 0 : false,
            isHeaderItemSelected: headerItem ? headerItem.selected : false,
            headerItem: headerItem,
            footerItem: footerItem,
            ddListItem: listItems ? JSON.parse(JSON.stringify(listItems)) : null
        };
    }

    toggle(doneClicked) {
        const { dropdownOpen, isFooterItemSelected, isHeaderItemSelected/*, ddListItem*/ } = this.state;
        const ddListItem = this.props.listItems;
        if (dropdownOpen && this.props.onDismiss && doneClicked) {
            var footerItem = this.props.footerItem;
            if (footerItem) {
                footerItem.selected = isFooterItemSelected;
            }

            var headerItem = this.props.headerItem;
            if (headerItem) {
                headerItem.selected = isHeaderItemSelected;
            }

            this.props.onDismiss(headerItem, ddListItem, footerItem);
        } else {
            //this.setState({
            //    isFooterItemSelected: this.props.footerItem ? this.props.footerItem.selected : false,
            //    isHeaderItemSelected: this.props.headerItem ? this.props.headerItem.selected : false,
            //    ddListItem: this.props.listItems ? JSON.parse(JSON.stringify(this.props.listItems)) : null
            //});
        }
        this.setState({ dropdownOpen: !dropdownOpen, touched: true });
    }

    selectUnselectAllItems(value, callback) {
        const { headerItem/*, ddListItem*/ } = this.state
        const ddListItem = this.props.listItems;
        //let tempListItem = ddListItem;
        //tempListItem.forEach(item => item.selected = value);
        ddListItem.forEach(item => item.selected = value);
        headerItem.selected = value;
        this.setState({
            isHeaderItemSelected: value,
            //ddListItem: ddListItem,//tempListItem,
            headerItem
        }, () => {
            if (callback) {
                callback(headerItem, ddListItem);
            }
        });
    }

    onHeaderItemSelected() {
        this.selectUnselectAllItems(!this.state.isHeaderItemSelected);
    }

    onListItemSelected(index) {
        //const { ddListItem } = this.state;
        const ddListItem = this.props.listItems;
        //let tempListItem = ddListItem;
        //tempListItem[index].selected = !tempListItem[index].selected;
        ddListItem[index].selected = !ddListItem[index].selected;
        const selected = ddListItem.filter(item => item.selected);
        this.setState({
            isHeaderItemSelected: selected.length === ddListItem.length
            //isHeaderItemSelected: selected.length === tempListItem.length,
            //ddListItem: tempListItem
        });
    }

    onFooterItemSelected() {
        const { isFooterItemSelected/*, ddListItem*/ } = this.state;
        const ddListItem = this.props.listItems;        
        //let tempListItem = ddListItem;

        if (!isFooterItemSelected) {
            //tempListItem.forEach(item => item.selected = false);
            ddListItem.forEach(item => item.selected = false);
            this.setState({
                isFooterItemSelected: true,
                isHeaderItemSelected: false,
                //ddListItem: tempListItem
            });
        } else {
            this.setState({
                isFooterItemSelected: false
            });
        }
    }

    onDoneClicked() {
        this.toggle(true);
    }

    updateDropDownList() {
        this.setState({
            isFooterItemSelected: this.props.footerItem ? this.props.footerItem.selected : false,
            isHeaderItemSelected: this.props.headerItem ? this.props.headerItem.selected : false,
            ddListItem: this.props.listItems ? JSON.parse(JSON.stringify(this.props.listItems)) : null
        });
    }

    render() {
        const { className, disabled, footerItem, headerItem, listItems, name, placeholder, showAsInvalid, multiSelect, showClearBtn } = this.props;
        const { /*ddListItem, */dropdownOpen, invalidInput, isFooterItemSelected, isHeaderItemSelected, touched } = this.state;
        const textFieldName = this.props.textFieldName ? this.props.textFieldName : 'text';
        const ddListItem = listItems;
        //if (!dropdownOpen && listItems && listItems.length > 0) {
        //    this.updateDropDownList();
        //}

        const footerEnabled = footerItem && (isFooterItemSelected || !listItems || listItems.length === 0);
        const oneOption = (!footerItem && ddListItem && ddListItem.length === 1) || (footerEnabled && (!listItems || listItems.length === 0));
        const showHeaderItem = headerItem && !oneOption && ddListItem && ddListItem.length > 1;
        const placeholderLabel = placeholder ? placeholder : (!oneOption ? `Select ${multiSelect ? name + 's' : 'a ' + name}` : name);
        const disableDropDown = disabled || oneOption;
        let selectedItem = null;

        if (footerEnabled) {
            selectedItem = footerItem[textFieldName];
        } else if (isHeaderItemSelected && showHeaderItem) {
            selectedItem = headerItem[textFieldName];
        } else if (ddListItem && ddListItem.length > 0) {
            if (ddListItem.length === 1) {
                selectedItem = ddListItem[0][textFieldName];
            }
            else {
                const selected = ddListItem.filter(item => item.selected);
                if (selected.length === 1) {
                    selectedItem = selected[0][textFieldName];
                }
                else if (selected.length > 1) {
                    selectedItem = selected.length + ` ${name}s Selected`;
                }
            }
        }

        const containerClassName = (className ? className : "") + (selectedItem ? " input-not-empty" : " input-empty") + (touched ? " input-touched" : " input-untouched") + (invalidInput || showAsInvalid ? " input-invalid" : " input-valid");

        return (
            <div className={`bswhdropdown il-group ${containerClassName}`}>
                {!selectedItem && (!ddListItem || !ddListItem.length)
                    ? <div className="il-label" aria-hidden="true">No {name} is available.</div>
                    : <> <div className="il-label" aria-hidden="true"> {placeholderLabel}</div>
                        <Dropdown isOpen={dropdownOpen} toggle={this.toggle}>
                            {showClearBtn && selectedItem && !oneOption &&
                                <div className="clear-btn-container">
                                    <button className="clear-btn" type="button" aria-label="clear button" onClick={() => this.selectUnselectAllItems(false, this.props.onClear)}>
                                        <span className="icon-input-clear" />
                                    </button>
                                </div>
                            }
                            <DropdownToggle caret={!oneOption} className={!selectedItem ? "li-label" : ""} disabled={disableDropDown}>
                                {selectedItem && <div className="il-selection truncate">{selectedItem}</div>}
                            </DropdownToggle>
                            <DropdownMenu>
                                <div className="bswh-dropdown-list">
                                    {showHeaderItem && <DropdownItem toggle={false} disabled={footerEnabled} onClick={this.onHeaderItemSelected} className="header-dropdown-item">
                                        <div className="checkbox-container">
                                            <div className={"checkbox-input" + (isHeaderItemSelected ? " input-checked" : "") + (footerEnabled ? " input-disabled" : "")} />
                                            <span className="checkmark" />
                                            <span className="checkmark-label">{headerItem[textFieldName]}</span>
                                        </div>
                                    </DropdownItem>}
                                    {ddListItem && ddListItem.map((item, index) => (
                                        <DropdownItem key={name + index} toggle={false} disabled={footerEnabled} onClick={() => this.onListItemSelected(index)} className="list-dropdown-item">
                                            <div className="checkbox-container">
                                                <div className={"checkbox-input" + (item.selected ? " input-checked" : "") + (footerEnabled ? " input-disabled" : "")} />
                                                <span className="checkmark" />
                                                <span className="checkmark-label">{item[textFieldName]}</span>
                                            </div>
                                        </DropdownItem>
                                    ))}
                                    {footerItem && <>
                                        <DropdownItem divider />
                                        <DropdownItem toggle={false} onClick={this.onFooterItemSelected} className="footer-dropdown-item">
                                            <div className="checkbox-container">
                                                <div className={"checkbox-input" + (isFooterItemSelected ? " input-checked" : "")} />
                                                <span className="checkmark" />
                                                <span className="checkmark-label">{footerItem[textFieldName]}</span>
                                            </div>
                                        </DropdownItem>
                                    </>}
                                </div>
                                <DropdownItem toggle={false} disabled={selectedItem === null} onClick={this.onDoneClicked} className="dropdown-done-button">
                                    <div className={"btn btn-primary" + (selectedItem === null ? " btn-disabled" : "")}>DONE</div>
                                </DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                    </>
                }
            </div>
        );
    }
}

DropdownForm.propTypes = propTypes;